import { useEffect, useState } from "react";
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import BmpLayout from "../../bmp-Layout";
import { getLocalStoreItem } from '../../../../helpers/localStoreHandler';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import BsciInfo from '../../components/bsci-info/bsci-info';
import PageTopInfo from '../../components/page-top-info/page-top-info';
import style from '../../common-style/common-style.module.css';
import CircularProgress from '@mui/material/CircularProgress';
import BrandMarketList from "../../components/brand-market-list/brand-market-list";
import Button  from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { APPROVED, MESSAGES, REJECTED } from "../../utils/status";
import BmpSiteFaqTable from "../../components/Table/bmp-site-faq-table";
import useHttp from "../../hooks/useHttp";
// import { statusCounter } from "../../utils/functions";
import BmpPortal from "../../components/portal/bmp-portal";
import { headCellsSiteFaq as headCells } from '../../utils/table-head';
import BmpModal from "../../components/Modal/Bmp-Modal";

// let alreadyLive = 0;
// let alreadyRejected = 0;
// let liveSelected = 0;
// let rejectedSelected = 0;
let isInitial = true;

const BmpSiteFaq = () => {
    const [loadedData, setLoadedData] = useState({});
    const [selected, setSelected] = useState([]);
    const [isError, setIsError] = useState(null);
    const history = useHistory();
    const [isLoading, setIsLoading] = useState({main: false, approve: false, reload: false});
    const brandLocale = useSelector(state => state.LocaleSelector);
    const [modalInfo, setModalInfo] = useState({state: '', active: false }); 
    const [refreshData, setRefreshData] = useState(false);
    const [snackbarState, setSnackbarState] = useState({open: false, message: '', severity: 'success'});
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(20);
    const {sendRequest, error } = useHttp();
    const isLocalData = (getLocalStoreItem('bmpSelectedLocale') && JSON.parse(getLocalStoreItem('bmpSelectedLocale'))) || null;
    const info = isLocalData || brandLocale;
    const brand = info.brand.value;
    const locale = info.locale.value;
    const hasData = Object.keys(loadedData).length > 0;
    const faqData = hasData ? loadedData?.data[0] : [];
    const plural = selected.length > 1;

    const updateLoadingState = (key, value) => {
        setIsLoading(prev => ({ ...prev, [key]: value }));
    };
    
    useEffect(()=>{ 
        if (!refreshData) {
            return;
        }
        const reFetch = async() => {
            updateLoadingState('reload', true);
            try {
                const data = await sendRequest(`faq/${brand}/${locale}?pageSize=${rowsPerPage}&pageNumber=${page+1}`);
                if (data.message) {
                    throw new Error(data.message);
                }
                setLoadedData(data);
            } catch(err) {
                window.location.reload();
                console.error(err);
            }
            updateLoadingState('reload', false);
            setRefreshData(false);
        };
        reFetch();
    }, [refreshData, brand, locale, sendRequest, page, rowsPerPage]);


    useEffect(() => {
        if (!brand || !locale) {
            return history.push('/dashboard/brand-manager-portal');
        }
        let isMounted = true;
        const fecthData = async() => {
            isInitial ? updateLoadingState('main', true) : updateLoadingState('reload', true);
            try {
                const data = await sendRequest(`faq/${brand}/${locale}?pageSize=${rowsPerPage}&pageNumber=${page+1}`);
                if (isMounted) {
                    setLoadedData(data.message ? {} : data);
                    setIsError(data.message || null); 
                }
            } catch (err) {
                console.error(err);
                setLoadedData({});
            }
            isInitial ? updateLoadingState('main', false) : updateLoadingState('reload', false);
            isInitial = false;
        }
        fecthData();
        return () => {
            isMounted = false; // Cleanup function to set flag to false
        };
    }, [sendRequest, brand, locale, history, page, rowsPerPage]);

    // const validateFaqSelection = (faq, selected) => {
    //     const approvedCount = faq.filter(item => item.content_status === APPROVED).length;
    //     const selectedApprovedCount = selected.filter(selectId => faq.find(faqItem => faqItem.faq_id === selectId && faqItem.content_status === APPROVED)).length;
    //     rejectedSelected = selected.filter(selectId => faq.find(faqItem => faqItem.faq_id === selectId && faqItem.content_status === REJECTED)).length;
    //     let validationResult = true;
    //     liveSelected = selectedApprovedCount;
    //     if (approvedCount >= 3) {
    //         validationResult = true;
    //     } else {
    //         validationResult = (selected.length + (approvedCount - selectedApprovedCount) >= 3);
    //     }
    //     return validationResult;
    // };

    // const validateFaqSelectionMax = (faq, selected) => {
    //     const approvedCount = faq.filter(item => item.content_status === APPROVED).length;
    //     const selectedApprovedCount = selected.filter(selectId => faq.find(faqItem => faqItem.faq_id === selectId && faqItem.content_status === APPROVED)).length;
    //     let validationResult = !(selected.length + (approvedCount - selectedApprovedCount) > 10);
    //     return validationResult;
    // };

    const validateFaqSelection = () => {
        let validationResult = { isValid: false, message: null };
        for (let i = 0; i < selected.length; i++ ) {
            const totalApproved = loadedData?.totalApproved || 0;
            const selectedApprovedCount = selected.filter(item => item.content_status === APPROVED).length;
            const totalConsideredCount = totalApproved + (selected.length - selectedApprovedCount);
            if (totalConsideredCount < 3) {
                validationResult = { isValid: true, message: 'Please review at least 3 FAQs' };
            } else if (totalConsideredCount > 10) {
                validationResult = { isValid: true, message: 'You can approve a maximum of 10 FAQs for publication on the site' };
            } else if (totalApproved >= 10) {
                validationResult = { isValid: true, message: 'You can approve a maximum of 10 FAQs for publication on the site' };
            }
        }
        return validationResult;
    };

    const handleOpenModal = (state) => {
        // alreadyLive = faqData.faq.filter(item => item.content_status === APPROVED).length;
        // alreadyRejected = faqData.faq.filter(item => item.content_status === REJECTED).length;

        // if (state === 'approve') {
        //     if (!validateFaqSelection(faqData.faq, selected)) {
        //         setSnackbarState(prev => ({
        //             ...prev,
        //             open: true,
        //             message: 'Please review at least 3 FAQs',
        //             severity: 'error'
        //         }));
        //         return;
        //     }
        //     if (!validateFaqSelectionMax(faqData.faq, selected)) {
        //         setSnackbarState(prev => ({
        //             ...prev,
        //             open: true,
        //             message: 'You can approve a maximum of 10 FAQs for publication on the site',
        //             severity: 'error'
        //         }));
        //         return;
        //     }
        // }

        if (state === 'approve') {
            const {isValid, message} = validateFaqSelection();
            if (isValid) {
                setSnackbarState(prev => ({
                    ...prev,
                    open: true,
                    message: message,
                    severity: 'error'
                }));
                return;
            }
        }
        setModalInfo({
            state: state,
            active: true
        });
        
    };

    const confirmAction = async() => {
        const {doc_id} = faqData;
        const {subCollection_uid} = faqData.faq[0];
        const selectedFaq = selected.map(item => ({faq_id: item.faq_id}));
        const data = [
            {
                doc_id,
                subCollection_uid,
                action: modalInfo.state,
                locale,
                faq: selectedFaq
            }
        ];
        updateLoadingState('approve', true);
        try {
            const response = await sendRequest('faq', 'POST', data);
            if (response && response[0].status === 500) {
                throw new Error(response[0].message);
            }
            setRefreshData(true);
            setSnackbarState(prev => ({
                ...prev,
                open: true,
                severity: 'success',
                message: `Item ${modalInfo.state === 'approve' ? 'Approved' : 'Rejected'} successfully!`,
            }));
            setSelected([]);
        } catch(err) {
            setSnackbarState(prev => ({
                ...prev,
                open: true,
                message: err.message || MESSAGES.dataFailed,
                severity: 'error'
            }));
            console.error(err);
        } 
        updateLoadingState('approve', false);
        setModalInfo(prev => ({
            ...prev,
            active:false
        }));
    }

    const handleSnackClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbarState(prev => ({
            ...prev,
            open: false
        }))
    };

    // const status_counts = statusCounter(hasData ? loadedData.data[0]?.faq : []);
    // const liveSelected = selected.filter(item => item.content_status === APPROVED).length;
    // const rejectedSelected = selected.filter(item => item.content_status === REJECTED).length;
    const alreadyLive = selected.filter(item => item.content_status === APPROVED).length;
    const alreadyRejected = selected.filter(item => item.content_status === REJECTED).length;

    return (
        <BmpLayout>
            {isLoading.main && (
                <div className={style.loader}>
                    <CircularProgress />
                </div>
            )}

            {isLoading.reload && (
                <BmpPortal />
            )}

            {!isLoading.main && (
                <div className={style['main-container']}>
                    <div className={style['main-container-inner']}>
                        <BrandMarketList />

                        {(error || isError) && (
                            <Alert severity="error" sx={{marginTop: '30px'}}>
                                <AlertTitle>Error</AlertTitle>
                                {error || isError}
                            </Alert>
                        )}
                        {!error && !isError && !hasData && !isLoading.reload && (
                            <Alert severity="info" sx={{marginTop: '30px'}}>
                                No data found!
                            </Alert>
                        )}
                        {!error && !isError && hasData && (
                            <>
                                <PageTopInfo 
                                    currentDate={loadedData?.generation_date.current_generation_date} 
                                    nextDate={loadedData?.generation_date.next_generation_date} 
                                    // counts={status_counts}
                                    totalApproved={loadedData?.totalApproved || 0}
                                    totalPending={loadedData?.totalPending || 0}
                                    totalRejected={loadedData?.totalRejected || 0}
                                    title="Auto-Generated Site-wide/Brand FAQs" 
                                    lastUpdate={loadedData?.lastActivity}
                                />
                                
                                <BmpSiteFaqTable 
                                    headCells={headCells} 
                                    loadedData={loadedData}
                                    selected={selected}
                                    setSelected={setSelected}
                                    page={page}
                                    setPage={setPage}
                                    rowsPerPage={rowsPerPage}
                                    setRowsPerPage={setRowsPerPage}
                                    setRefreshData={setRefreshData}
                                    setSnackbarState={setSnackbarState}
                                    locale={locale}
                                />

                                <div className={style.tableActions}>
                                    <Button onClick={() => handleOpenModal('approve')} variant="contained" color="success" disabled={!selected.length}>Approve</Button>
                                    <Button onClick={() => handleOpenModal('reject')} variant="outlined" color="error" disabled={!selected.length}>Reject</Button>
                                </div>

                                <BsciInfo />
                            </>
                        )}
                    </div>
                </div>
            )}
            
            {modalInfo.active && (
                <BmpModal 
                    modalInfo={modalInfo} 
                    setModalInfo={setModalInfo} 
                    confirmAction={confirmAction} 
                    loading={isLoading.approve} 
                    plural={plural}
                >
                    <Typography x={{ mt: 1 }}>
                        <span>
                            {selected.length} FAQ{plural ? 's' : ''} selected 
                            {modalInfo.state === 'approve' && alreadyLive > 0 ? <small> ({alreadyLive} already Live)</small> : ''}
                            {modalInfo.state === 'reject' && alreadyRejected > 0 ? <small> ({alreadyRejected} already Rejected)</small> : ''}
                            {/* {liveSelected > 0 && modalInfo.state === 'approve' ? <small> ({liveSelected} already Live)</small> : ''}{rejectedSelected > 0 && modalInfo.state === 'reject' ? <small> ({rejectedSelected} already Rejected)</small> : ''}{alreadyLive > 0 && `, ${alreadyLive} Live`}{alreadyRejected > 0 && `, ${alreadyRejected} Rejected`} */}
                        </span>
                    </Typography> 
                </BmpModal>
            )}
            

            <Snackbar 
                open={snackbarState.open} 
                autoHideDuration={10000} 
                onClose={handleSnackClose} 
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert
                    onClose={handleSnackClose}
                    severity={snackbarState.severity || 'success'}
                    variant="filled"
                    sx={{ width: '100%', whiteSpace: 'pre-wrap'}}
                >
                    {snackbarState.message && snackbarState.message.replace(/\\n/g, '\n')}
                </Alert>
            </Snackbar>
            
            
        </BmpLayout>
    )
}

export default BmpSiteFaq;